<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-lr`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.0234 8C10.9189 8 10.0234 7.10457 10.0234 6 10.0234 4.89543 10.9189 4 12.0234 4L20.0234 4C21.128 4 22.0234 4.89543 22.0234 6 22.0234 7.10457 21.128 8 20.0234 8L12.0234 8zM12 14C10.8954 14 10 13.1046 10 12 10 10.8954 10.8954 10 12 10L22 10C23.1046 10 24 10.8954 24 12 24 13.1046 23.1046 14 22 14L12 14zM12.0234 20C10.9189 20 10.0234 19.1046 10.0234 18 10.0234 16.8954 10.9189 16 12.0234 16L20.0234 16C21.128 16 22.0234 16.8954 22.0234 18 22.0234 19.1046 21.128 20 20.0234 20L12.0234 20z" :fill="useCurrentColor ? 'currentColor' : '#BEDAFF'"/><path d="M2.24609 5.58151C2.24609 4.13097 3.42199 2.95508 4.87252 2.95508C6.32306 2.95508 7.49895 4.13097 7.49895 5.58151L7.49895 18.418C7.49895 19.8685 6.32306 21.0444 4.87252 21.0444C3.42199 21.0444 2.24609 19.8685 2.24609 18.418L2.24609 5.58151Z" :fill="useCurrentColor ? 'currentColor' : '#165DFF'"/></svg>
</template>
<script>

export default {
  name: 'IconColorLr',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
